<template>
    <b-modal
        id="newClientModal"
        ref="newClientModal"
        :lazy="true"
        :no-close-on-backdrop="true"
        :scrollable="true"
        title-tag="h2"
        title="New Client"
        :hide-backdrop="hideBackdrop"
    >
        <b-alert
            v-model="showMobileAppRequirementErrorMessage"
            variant="danger"
            dismissible
        >
            <i class="cus-exclamation"></i>
            Client mobile app add-on is enabled. Please insert either the
            client's email address OR mobile phone number to proceed.
        </b-alert>
        <client
            modal-id="newClientModal"
            ref="newClientForm"
            :data="client_data"
            :group_insert="true"
            :is-new="isNew"
        />
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.newClientModal.hide()"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button @click="save" v-else variant="primary">Save</b-button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Client from "./form.vue";
import ClientService from "@/services/client";
import { merge } from "lodash";
import EXTENSIONS from "@/constants/extensions";
import ClientMixins from "@/mixins/client";

export default {
    components: {
        Client
    },
    props: {
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        // is new client
        isNew: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ClientMixins],
    data() {
        return {
            client_data: {
                reminders: [],
                reminder_options: [],
                home_country_code: null,
                mobile_country_code: null,
                fax_country_code: null,
                group_insert: false,
                work_country_code: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                country: null,
                county: null,
                id: null
            },
            promise: null,
            loading: false,
            showMobileAppRequirementErrorMessage: false
        };
    },
    created() {},
    methods: {
        open(event) {
            this.client_data = merge(this.client_data, event);
            this.$refs.newClientModal.show();
        },
        async save() {
            try {
                let refForm = this.$refs.newClientForm;
                let isValid = await refForm.$validator.validateAll();
                let isMobileAppExtEnabled = this._isExtensionEnabled(
                    EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
                );

                if (!isValid) {
                    throw new Error("validator");
                }

                if (isMobileAppExtEnabled) {
                    let email = this.client_data.email || "";
                    let mobile = this.client_data.mobile || "";

                    if (email === "" && mobile === "") {
                        throw new Error("REQUIRES_EMAIL_PHONE");
                    }
                }

                // proper reminder option values
                this.client_data.reminder_options = this.$refs.newClientForm.remindersToString();

                this.loading = true;

                // check if new client is shared client APPS#2882
                let resource, message;
                if (this.client_data.id) {
                    const res = await ClientService.update(
                        this.client_data.id,
                        this.client_data
                    );
                    resource = res.resource;
                    message = res.message;
                } else {
                    let uri = `${process.env.ACTOR_SERVICE}client`;
                    const res = await this.$http.post(uri, this.client_data);
                    resource = res.data.response.resource;
                    message = res.data.response.message;
                }

                if (resource) {
                    this.client_data = merge(this.client_data, resource);

                    this.client_data.new = true;
                    this.$emit("saved", this.client_data);
                    this._message("Client successfully added", "success");
                    this.$refs.newClientModal.hide();
                } else {
                    throw new Error(JSON.stringify(message));
                }
            } catch (err) {
                if (err.message === "REQUIRES_EMAIL_PHONE") {
                    this.showMobileAppRequirementErrorMessage = true;
                } else if (err.message !== "validator") {
                    this._message(err.message, "danger");
                }

                this.loading = false;
            }
        }
    }
};
</script>
